import React from 'react';
import { IssueItem } from '../../models/issueItem';
import IssueCard from './IssueCard';
import './IssuesTable.css';
import { useNavigate } from 'react-router-dom';
import { useIssue } from '../../contexts/IssueContext';

interface IssuesCardProps {
  issues: IssueItem[];
}

const IssuesCardView: React.FC<IssuesCardProps> = ({ issues }) => {

  const { setSelectedIssue } = useIssue();
  const navigate = useNavigate();

  const handleClick = ((issue : IssueItem) => {
    console.log( `sending out the issue ${issue.id}`)
    setSelectedIssue(issue);
    navigate(`/issue/${issue.id}`);
  });

  return (
    <div className="issues-card-container">
      {issues.map((issue) => (
        <div key={issue.id} 
           className="issue-card cursor-pointer"
           onClick={() => handleClick(issue)}
           >
          <IssueCard key={issue.id} issue={issue}/>
        </div>
      ))}
    </div>
  );
};

export default IssuesCardView;
